if (!customElements.get('slick-product-modal')) {
  customElements.define(
    'slick-product-modal',
    class SlickProductModal extends ModalDialog {
      constructor() {
        super();
        this.handleEscape = (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        };
      }

      hide() {
        document.removeEventListener('keydown', this.handleEscape);
        super.hide();
      }

      show(opener) {
        document.addEventListener('keydown', this.handleEscape);
        super.show(opener);
      }
    },
  );
}
